<template>
  <div class='have-zoom'>
    <h1>活动议程管理列表</h1>
    <div class="table">
      <div class="table-head">
        <div class="id">活动id</div>
        <div class="type">活动类型</div>
        <div class="city">活动地点</div>
        <div class="time">活动时间</div>
        <div>活动议程</div>
      </div>
      <div class="table-box">
        <div class="table-row" v-for="(items,index) in tableShow" :key="index">
          <div class="id">
            {{items[0].acid}}
            <span class="change" @click="editRow(items[0].type,items[0].acid,items[0].id)">查看</span>
          </div>
          <div class="type">{{items[0].type}}</div>
          <div class="city">{{items[0].city}}</div>
          <div class="time">{{changeTime(items[0].acTime,'Y')}}</div>
          <div class="agendas">
            <div class="agenda" v-for="(item,index) in items" :key="index">
              <div class="time">
                <span>{{changeTime(item.startTime,'H')}}</span>-<span>{{changeTime(item.endTime,'H')}}</span>
              </div>
              <p class="doing" :title="item.doing">{{item.doing}}</p>
              <p class="title" :title="item.title">{{item.title}}</p>
              <p class="guest" :title="item.guest">{{item.guest}}</p>
              <p class="jobTitle" :title="item.jobTitle">{{item.jobTitle}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="normal-pagination">
      <el-pagination layout="prev, pager, next" :page-size="4" :total="total" style="float:right" @current-change='changePage'>
      </el-pagination>
    </div>
  </div>

</template>

<script>
export default {
  data() {
    return {
      tableData: [],
      tableShow: [],
      originData: [],
      total: null
    };
  },
  methods: {
    changeTime(tim, type) {
      let time = new Date(tim);
      if (type === "Y") {
        return `${time.getFullYear()}-${time.getMonth()}-${time.getDate()}`;
      }
      if (type === "H") {
        let mi = time.getMinutes();
        if (mi === 0) {
          mi = `00`;
        }
        return `${time.getHours()}:${mi}`;
      }
    },
    changePage(id) {
      const start = (id - 1) * 4;
      const end = start + 4;
      this.tableShow = this.tableData.slice(start, end);
    },
    editRow(type, acid,id) {
      this.$router.push(`/agenda/am/post/${type}/${acid}/${id}`);
    },
    initData() {
      this.$http.agenda_list("AM").then(res => {
        if (res.data.statusCode === 200) {
          this.originData = res.data.result.reverse();
          this.initTabData(this.originData);
          // this.changePage(1);
        } else {
          this.$message.error("数据请求未成功");
        }
      });
    },
    initTabData(data) {
      for (let i = 0; i < data.length; i) {
        let holdData = data[i];
        let newRow = [];
        for (let k = i; k < data.length; k++) {
          if (
            holdData.acid === data[k].acid &&
            holdData.type === data[k].type
          ) {
            newRow.push(data[k]);
            data.splice(k, 1);
            k--;
          }
        }
        this.tableData.push(newRow);
      }
      this.total = this.tableData.length;
      this.changePage(1);
    }
  },
  computed: {
    // total() {
    //   return this.tableData.length;
    // }
  },
  mounted() {
    this.initData();
  }
};
</script>

<style scoped>
.el-table__fixed,
.el-table__fixed-right {
  overflow: hidden;
}
div {
  box-sizing: border-box;
}
.table {
  font-family: "Microsoft YaHei";
  color: #878d99;
  width: 100%;
  max-height: 700px;
  font-size: 16px;
  margin-top: 20px;
}
.table-head {
  display: flex;
  width: 95%;
  justify-content: flex-start;
  font-weight: 600;
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid #ccc;
}

.table-head > div {
  margin-right: 20px;
}
.table-box {
  width: 95%;
  display: flex;
  flex-direction: column;
}
.table-row {
  /* 这里必须使用display: -webkit-box;才能保持样式正确 */
  display: -webkit-box;
  justify-content: flex-start;
  height: 146px;
  padding: 10px 0;
  border-bottom: 1px solid #ccc;
  transition: background-color 300ms;
  font-size: 14px;
  color: rgb(90, 94, 102);
}
.table-row:hover {
  background-color: rgb(236, 245, 255);
}
.table-row > div {
  margin-right: 20px;
}
.id {
  width: 50px;
}
.type,
.city {
  width: 80px;
}
.time {
  min-width: 110px;
  overflow: hidden;
  border-right: 1px solid #ccc;
}
.agendas {
  flex-grow: 1;
  display: flex;
}
.agenda {
  display: flex;
  flex-direction: column;
  min-width: 80px;
  justify-content: space-between;
  margin-right: 15px;
}
.agenda > p {
  min-height: 21px;
}
.change {
  color: rgb(36, 120, 255);
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/backend/agenda-list.vue